import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import PrimarySelect from "../../Inputs/PrimarySelect/PrimarySelect";
import PrimaryTextField from "../../Inputs/PrimaryTextField/PrimaryTextField";
import PrimaryButton from "../../Buttons/PrimaryButton/PrimaryButton";
import TertiaryButton from "../../Buttons/TertiaryButton/TertiaryButton";
import CloseIcon from "@mui/icons-material/Close";

export default function GlobalSearchBar({ 
  selectedSearchType, 
  setSelectedSearchType,
  searchInput,
  setSearchInput,
  handleSearch,
  handleClose,
  isLoading,
  searchDisabled
}) {
  const globalSearchTypes = [
    {
      name: "Carrier Name",
      value: "carrierName"
    },
    {
      name: "MC#",
      value: "mcNumber"
    },
    {
      name: "DOT#",
      value: "dotNumber"
    },
    {
      name: "Order ID",
      value: "order-id"
    }
  ];

  return (
    <Box sx={{ display: "flex" }}>
      <Box>
        <PrimarySelect 
          id="search-type"
          options={globalSearchTypes}
          onChange={setSelectedSearchType}
          value={selectedSearchType}
          nameKey="name"
          valueKey="value"
          width="160px"
        />
      </Box>
      <Box sx={{ margin: "0 40px" }}>
        <PrimaryTextField
          id="global-search-bar"
          value={searchInput}
          onChange={setSearchInput}
          width="460px"
          onEnter={handleSearch}
          placeholder="Search Input*, *Search Input*, Search Input "
        />
      </Box>
      <Box>
        <PrimaryButton
          label="Search"
          width="60px"
          onClick={handleSearch}
          isLoading={isLoading}
          disabled={searchDisabled || isLoading}
        />
      </Box>
      <Box sx={{ marginLeft: "auto" }}>
        <TertiaryButton 
          onClick={handleClose}
          startIcon={CloseIcon}
        />
      </Box>
    </Box>
  );
}

GlobalSearchBar.propTypes = {
  selectedSearchType: PropTypes.string.isRequired,
  setSelectedSearchType: PropTypes.func.isRequired,
  searchInput: PropTypes.string.isRequired,
  setSearchInput: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  searchDisabled: PropTypes.bool.isRequired
};